import { type ReactNode } from "react";

export interface FieldSetProps {
  children: ReactNode;
  subTitle?: string;
  title?: ReactNode;
}

export function FieldSet({ children, subTitle, title }: FieldSetProps) {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-0.5">
        {title && <h3 className="text-headingmd">{title}</h3>}

        {subTitle && <p className="text-bodysm text-textSubdued">{subTitle}</p>}
      </div>

      {children}
    </div>
  );
}
